export default __webpack_public_path__ + "static/media/04Morán.238f8f9d.jpg";